import {clamp, texture} from "p3";
import BossFightScene from "../../scenes/BossFightScene";
import GameScene from "../../scenes/GameScene";

export default class HealthBarHeart extends PIXI.Container {
    constructor(maxHealth, shield) {
        super();

        this._health = maxHealth || 4;
        this._maxHealth = maxHealth;
        this._shield = shield;

        this._view = null;

        this._warning = false;
        this._warningTime = 0;
        this._warningSpeed = 10;

        this._tween = null;

        this.init();
    }

    init() {

        const empty = new PIXI.Sprite(texture(this._shield ? "icon_life_shield_off" : "icon_life_off"));
        empty.anchor.set(0.5);
        this.addChild(empty);

        this._view = new P3.AdditiveSprite(PIXI.Texture.EMPTY);
        this._view.blendStrength = 1;
        this._view.blendPasses = 2;
        this._view.anchor.set(0.5);
        this.addChild(this._view);

        this.health = 4;
    }

    update() {
        if (this._warning && this._health > 0) {
            this._view.blendStrength = Math.max(0, (Math.sin(this._warningTime) + 0.8) / 1.8) * 0.5;
            this._warningTime += this._warningSpeed * window.dt;
        } else {
            this._view.blendStrength = 0;
        }
    }

    /**
     * @param {number} [delay=0]
     * @return {Promise}
     */
    animateIn(delay = 0) {
        return new Promise((resolve) => {
            this.stopAnimation();

            this.scale.set(1);

            this._tween = gsap.timeline({ onComplete: resolve });

            if(GameScene.active) {
                GameScene.active.addTween(this._tween);
            } 
            else if(BossFightScene.active) {
                BossFightScene.active.addTween(this._tween);
            }

            this._tween.add(gsap.to(this.scale, 0.08, {
                delay: delay,
                x: 1.2,
                y: 1.2,
                ease: Linear.easeNone
            }));
            this._tween.add(gsap.to(this.scale, 0.1, {
                x: 1,
                y: 1,
                ease: "back.out(2.4)"
            }));
        });
    }

    stopAnimation() {
        if (this._tween) {
            if(GameScene.active) {
                GameScene.active.removeTween(this._tween, true);
            } 
            else if(BossFightScene.active) {
                BossFightScene.active.removeTween(this._tween, true);
            }
            this._tween = null;
        }
    }

    /**
     * @return {number}
     */
    get health() {
        return this._health;
    }

    /**
     * @return {number}
     */
    get maxHealth() {
        return this._maxHealth;
    }

    /**
     * @param {number} value
     */
    set health(value) {
        this._health = clamp(value, 0, this._maxHealth);
        this._warningTime = 0;

        let shield = '';
        if (this._shield) {
            shield = '_shield';
        }

        let tex;
        switch (this._health) {
            default:
            case 0: {
                tex = PIXI.Texture.EMPTY;
                break;
            }
            case 1: {
                tex = texture("icon_life" + shield + "_on_25pc");
                break;
            }
            case 2: {
                tex = texture("icon_life" + shield + "_on_50pc");
                break;
            }
            case 3: {
                tex = texture("icon_life" + shield + "_on_75pc");
                break;
            }
            case 4: {
                tex = texture("icon_life" + shield + "_on_100pc");
                break;
            }
        }
        this._view.texture = tex;
    }

    /**
     * @return {boolean}
     */
    get warning() {
        return this._warning;
    }

    /**
     * @param {boolean} value
     */
    set warning(value) {
        this._warning = value;
        this._warningTime = 0;
    }

    /**
     * @return {boolean}
     */
    get shield() {
        return this._shield;
    }
}